import { nothing, html, css } from "lit";
import { ifDefined } from "lit-html/directives/if-defined.js";
import { SignalWatcher } from "@lit-labs/preact-signals";
import "../../atom/ModalBase/index.js";
import "../../atom/Text/index.js";
import "../Button/index.js";
import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { testingAttr } from "../../../directives/testingAttr.js";
import { TestingAttrs } from "./dialog.selectors.js";
import { isMobile, breakpoints } from "../../../responsive/index.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DsfDialog = class extends SignalWatcher(BaseComponent) {
  constructor() {
    super();
    this.dsf_focus_selector = "button.bg-primary-300";
  }
  render() {
    if (!this.dsf_open) {
      return nothing;
    }
    return html`
      <dsf-modal-base
        exportparts="overlay, modal"
        dsf_focus_selector=${ifDefined(this.dsf_focus_selector)}
      >
        <div slot="content" class="flex flex-auto flex-col gap-10 overflow-auto p-20 text-center">
          <dsf-text dsf_level="s-medium">${this.dsf_title}</dsf-text>
          <dsf-text dsf_level="xs">${this.dsf_description}</dsf-text>
        </div>
        <div slot="footer" class="flex gap-8 border-t border-t-neutral-100 p-16">
          <dsf-button
            @click=${() => this.emit("cancel")}
            dsf_level="secondary"
            dsf_size=${isMobile() ? "medium" : "large"}
            ${testingAttr(TestingAttrs.cancelButton)}
          >
            ${this.dsf_cancel_text}
          </dsf-button>
          <dsf-button
            @click=${() => this.emit("confirm")}
            dsf_level=${this.dsf_destructive ? "destructive" : "primary"}
            dsf_size=${isMobile() ? "medium" : "large"}
            ${testingAttr(TestingAttrs.confirmButton)}
            >${this.dsf_confirm_text}</dsf-button
          >
        </div>
      </dsf-modal-base>
    `;
  }
};
DsfDialog.shadowRootOptions = {
  ...BaseComponent.shadowRootOptions,
  delegatesFocus: false
};
DsfDialog.properties = {
  dsf_description: { type: String },
  dsf_title: { type: String },
  dsf_confirm_text: { type: String },
  dsf_cancel_text: { type: String },
  dsf_destructive: { type: Boolean, reflect: true },
  dsf_focus_selector: { type: String },
  dsf_open: { type: Boolean, reflect: true }
};
DsfDialog.styles = [
  ...BaseComponent.styles,
  css`
      dsf-button {
        flex-grow: 1;
      }

      @media only screen and (min-width: ${breakpoints.mobile}px) {
        ::part(modal) {
          min-width: 400px;
          max-width: 660px;
        }
      }
    `
];
DsfDialog = __decorateClass([
  defineElement("dsf-dialog")
], DsfDialog);
export {
  DsfDialog
};
